import { apiBuilder, prefixApi } from "@zodios/core";
import { z } from "zod";
import { orgSchema } from "../../common/orgSchema";

const agencyOrgSchema = orgSchema.extend({
  has_payment_data: z.boolean(),
});

export type AgencyOrg = z.infer<typeof agencyOrgSchema>;

const createNewAgencySchema = z.object({
  name: z.string(),
  account_managers: z.array(z.number()),
});

const addAgencyAccountManagersSchema = z.object({
  agency_id: z.number(),
  account_managers: z.array(z.number()),
  action: z.literal("add_agency_account_managers"),
});

export type CreateNewAgencyPayload = z.infer<typeof createNewAgencySchema>;
export type AddAgencyAccountManagersPayload = z.infer<typeof addAgencyAccountManagersSchema>;

export const agencyApiDefinitions = prefixApi(
  "/api",
  apiBuilder({
    alias: "getAgencies",
    method: "get",
    path: "/manage/agency/",
    parameters: [
      {
        name: "include_orgs",
        type: "Query",
        schema: z.boolean().optional(),
      },
    ],
    status: 200,
    response: z.object({
      results: z.array(
        z.object({
          id: z.number(),
          name: z.string(),
          orgs: z.array(agencyOrgSchema).optional(),
        }),
      ),
    }),
  })
    .addEndpoint({
      alias: "createNewAgency",
      method: "post",
      path: "/manage/agency/",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: createNewAgencySchema,
        },
      ],
      status: 201,
      response: z.unknown(),
    })
    .addEndpoint({
      alias: "addAgencyAccountManagers",
      method: "put",
      path: "/manage/agency/",
      parameters: [
        {
          name: "body",
          type: "Body",
          schema: addAgencyAccountManagersSchema,
        },
      ],
      status: 200,
      response: z.unknown(),
    })
    .build(),
);
